import React from "react";
import { useSelector } from "react-redux";
import HexViewImage from "../Cloudinary/HexViewImage";

const FantasyStatsCard = ({
  title,
  imgConstrutor,
  imgDriver,
  pointsConstrutor,
  pointsDriver,
  prefix = null,
  suffix = null,
  driverName = "",
  constructorName = "",
  currentSeasonYear = null,
  driver = null,
  constructor = null,
}) => {
  const commonConfigState = useSelector((state) => state.commonConfig);
  const webConfigData = commonConfigState?.data?.config;

  return (
      <div className="si-fanStats__card">
        <div className="si-fanStats__card-title">{title}</div>
        <div className="si-fanStats__card-grid">
          <div className="si-fanStats__card-gridLft">
            <div className="si-fanStats__card-thumb">
              <HexViewImage player={constructor} />
            </div>
          </div>
          <div className="si-fanStats__card-gridMid">
            <div className="si-fanStats__card-gridMid-item">
              <div className="si-fanStats__card-score">
                <span>
                  {prefix ? prefix : null}
                  {pointsConstrutor}
                  {suffix ? ` ${suffix}` : null}
                </span>
              </div>
              <div className="si-fanStats__card-name">
                <span>{constructorName}</span>
              </div>
            </div>
            <div className="si-fanStats__card-gridMid-item">
              <div className="si-fanStats__card-score">
                <span>
                  {prefix ? prefix : null}
                  {pointsDriver}
                  {suffix ? ` ${suffix}` : null}
                </span>
              </div>
              <div className="si-fanStats__card-name">
                <span>{driverName}</span>
              </div>
            </div>
          </div>
          <div className="si-fanStats__card-gridRgt">
            <div className="si-fanStats__card-thumb">
              <HexViewImage player={driver} />
            </div>
          </div>
        </div>
      </div>
  );
};

export { FantasyStatsCard };
